import { defineComponent as t, openBlock as n, createBlock as a, normalizeProps as p, guardReactiveProps as l, withCtx as s, renderSlot as d, createElementVNode as e } from "vue";
import c from "../CdrIcon.vue.mjs";
const i = /* @__PURE__ */ e("g", null, [/* @__PURE__ */ e("path", {
  role: "presentation",
  d: "M15.293 16.707a1 1 0 001.414-1.414L9.121 7.707a1 1 0 10-1.414 1.414l7.586 7.586z"
}), /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z",
  "clip-rule": "evenodd"
})], -1), _ = /* @__PURE__ */ t({
  name: "ErrorStroke",
  __name: "error-stroke",
  props: {
    props: {
      type: Object
    }
  },
  setup(r) {
    return (o, m) => (n(), a(c, p(l(r.props)), {
      default: s(() => [d(o.$slots, "default"), i]),
      _: 3
    }, 16));
  }
});
export {
  _ as default
};
